/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { TransformationApiData } from "./TransformationApiData";
export const TransformationResponse = core.serialization.object({
    success: core.serialization.boolean(),
    data: TransformationApiData,
});
